import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 登录验证
export default new Vuex.Store({
  state: {
    user: {}
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user
      localStorage.setItem('userInfo', user)
      localStorage.setItem('login', true)
    },
    // 退出
    logout(state, user) {
      state.user = {}
      localStorage.setItem('userInfo', null)
      localStorage.setItem('login', false)
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/vuex/store.js